export default __webpack_public_path__ + "static/media/linus2.bcd8efad.webp";